import { render, staticRenderFns } from "./LastLessons.vue?vue&type=template&id=35df8754&"
import script from "./LastLessons.vue?vue&type=script&lang=js&"
export * from "./LastLessons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports